// PERF: o ChatSuite é whitelabel pt-BR. Importar os 56 idiomas (~23MB de fonte)
// inflava o bundle inicial do dashboard em ~2-3MB gzip — todo mundo baixava 50+
// idiomas que nunca usa. Mantemos português (pt_BR + pt), inglês (en, também
// fallback) e espanhol (es). Idiomas removidos caem no fallback (en) sem quebrar.
// Para reativar outros, basta voltar a importá-los aqui.
import en from './locale/en';
import es from './locale/es';
import pt from './locale/pt';
import pt_BR from './locale/pt_BR';

export default {
  en,
  es,
  pt,
  pt_BR,
};
